import React from 'react';
import { Coins } from 'lucide-react';
import { fundingSources } from '../data/mock';

const Funding = () => {
  return (
    <section id="funding" className="py-28 bg-gradient-to-br from-slate-50 via-white to-indigo-50/30 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-indigo-100/30 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-cyan-100/30 rounded-full blur-3xl"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-3 px-5 py-2.5 rounded-full glass-light border border-indigo-200 mb-8 shadow-lg shadow-indigo-100/50">
            <Coins className="h-5 w-5 text-indigo-600" />
            <span className="text-sm font-bold text-indigo-700 tracking-wide">FUNDING</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-6 leading-tight" style={{ fontFamily: "'Space Grotesk', sans-serif", letterSpacing: '-0.02em' }}>
            Our <span className="gradient-text">Funding Sources</span>
          </h2>
          <div className="w-32 sm:w-40 h-2 bg-gradient-to-r from-indigo-600 via-cyan-500 to-amber-500 mx-auto rounded-full shadow-lg mb-6"></div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 lg:gap-12 max-w-6xl mx-auto px-4">
          {fundingSources.map((source) => (
            <div 
              key={source.id}
              className="group relative flex justify-center"
            >
              <div className="glass-light p-8 sm:p-10 md:p-12 rounded-2xl hover:shadow-2xl hover:shadow-indigo-200/50 transition-all duration-300 hover:scale-105 border-2 border-indigo-100 hover:border-indigo-300 w-full flex items-center justify-center">
                <img 
                  src={source.logo} 
                  alt={source.alt}
                  className="h-32 sm:h-40 md:h-48 lg:h-56 w-auto object-contain transition-all duration-300"
                />
              </div>
              <div className="absolute -bottom-3 left-1/2 transform -translate-x-1/2 premium-gradient text-white px-4 sm:px-5 md:px-6 py-2 sm:py-2.5 rounded-full text-sm sm:text-base md:text-lg font-bold opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap shadow-lg">
                {source.alt}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Funding;
